import { getQualifiedDependents, hasQualifiedDependents, isMarried } from "./contact-builder";
import { BenefitGroup } from "./enums/benefit-group";
import { PlanType } from "./enums/plan-type";

export const refreshCompanyPaidPlan = (enrollments) => {
    const companyPaidPlan = enrollments.plans.find((p) => p.planType === PlanType.BasicLife);
    const selection = enrollments.selections.find(s => s.planId === companyPaidPlan.id);
    let companyPaid = {...selection};
    if(!selection){
      companyPaid = createCompanyPaidSelection(enrollments);
    }
    const hasDependents = hasQualifiedDependents(enrollments);
    if(hasDependents || isMarried(enrollments)){
      companyPaid.planOption = "2";
      companyPaid.dependents = getQualifiedDependents(enrollments);
    } else {
      companyPaid.planOption = "1";
      companyPaid.dependents = [];
    }
    return companyPaid;
}

const createCompanyPaidSelection = (enrollments) => {
  const plan = enrollments.plans.find((s) => s.planType === PlanType.BasicLife);

  return {
    planId: plan.id,
    planDescription: plan.name,
    planType: PlanType.BasicLife
  };
};
 
